import { render, staticRenderFns } from "./floor-style-2.vue?vue&type=template&id=5f72b495"
import script from "./floor-style-2.vue?vue&type=script&lang=js"
export * from "./floor-style-2.vue?vue&type=script&lang=js"
import style0 from "./floor-style-2.vue?vue&type=style&index=0&id=5f72b495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports